<div class="flex flex-col justify-between w-[25rem] h-[8rem]" [class]="direction">
  <!--
    a11y: top close (X) added — initial focus target ([focusInitial]=true) so
    on open AT users land here, not on the body content. Required by the
    audit for every popup.
  -->
  <div class="!flex justify-end">
    <mot-button matType="icon" icon="close"
      [ariaLabel]="closeText"
      class="!border-none !w-min !h-min cursor-pointer !bg-transparent" iconClass="!text-2xl"
      [focusInitial]="true"
      (onClick)="closeCard()" />
  </div>

  <p class="text-red-600 font-medium mb-2 text-center" [innerHTML]="errorMessage"></p>

  @if (isDesktop) {
    <div class="!flex justify-end !sticky bottom-2 px-2">
      <mot-button [text]="closeText"
        buttonClass="!bg-primary !w-4 !text-white !px-2 !py-3 !rounded-lg !align-middle mt-0.5" (onClick)="closeCard()" />
      </div>
    }
  </div>
